import Modal from '../../../../../components/Modal'
import MDBox from '../../../../../components/MDComponents/MDBox'
import MDInput from '../../../../../components/MDComponents/MDInput'
import MDTypography from '../../../../../components/MDComponents/MDTypography'
import Button from '../../../../../components/Button'
import useChangePassword from '../../../../change-password/useChangePassword'

const ChangePasswordModal = ({
  setIsChangePasswordModalOpen,
  isChangePasswordModalOpen,
}) => {
  const { handleSubmit, handleChange, inputs, errors, isLoading } =
    useChangePassword(setIsChangePasswordModalOpen)
  return (
    <Modal
      closeModal={() => setIsChangePasswordModalOpen(false)}
      title="Schimbare parola"
      isOpen={isChangePasswordModalOpen}
    >
      <div className="ml-auto mr-auto p-3 px-3 rounded-lg max-w-[500px] text-center">
        <MDBox component="form" role="form">
          <MDInput
            showPassword
            type="password"
            label="Parola curentă"
            variant="standard"
            fullWidth
            name="currentPassword"
            value={inputs.currentPassword}
            onChange={handleChange}
            error={errors.currentPasswordError}
            inputProps={{ style: { fontSize: 16 } }}
          />
          {errors.currentPasswordError && (
            <MDTypography variant="caption" color="error" fontWeight="light">
              Parola greșită
            </MDTypography>
          )}
          <MDInput
            showPassword
            type="password"
            label="Parola nouă"
            variant="standard"
            fullWidth
            name="password"
            value={inputs.password}
            onChange={handleChange}
            error={errors.passwordError}
            inputProps={{ style: { fontSize: 16 } }}
          />
          {errors.passwordError && (
            <MDTypography variant="caption" color="error" fontWeight="light">
              Parola trebuie să conțină minim 8 caractere
            </MDTypography>
          )}
          <MDInput
            showPassword
            type="password"
            label="Repetă parola nouă"
            variant="standard"
            fullWidth
            name="confirmPassword"
            value={inputs.confirmPassword}
            onChange={handleChange}
            error={errors.confirmPasswordError}
            inputProps={{ style: { fontSize: 16 } }}
          />
          {errors.confirmPasswordError && (
            <MDTypography variant="caption" color="error" fontWeight="light">
              Cele două parole nu coincid
            </MDTypography>
          )}

          <MDBox className="mt-4 mb-1">
            <Button
              isLoading={isLoading}
              onClick={handleSubmit}
              className="bg-btn-primary w-full h-10"
            >
              Schimbă parola
            </Button>
          </MDBox>
        </MDBox>
      </div>
    </Modal>
  )
}

export default ChangePasswordModal
